/**
 * Created with IntelliJ IDEA.
 * User: yniran
 * Date: 19/09/13
 * Time: 21:13
 * To change this template use File | Settings | File Templates.
 */

/**
 *
 *      Settings:
 *              direction (values: "down" or "up")
 *              text (values: String)
 *              number (value: Number)
 *              collection (value: Backbone Collection)
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");
    var $ = require("jquery");
    var Backbone = require("backbone");
    var Marionette = require("marionette");
    var Logger = require("logger");
    var template = require("ui/counter/templates/counter.tmpl");

    var Counter = Marionette.ItemView.extend({

        template: template,

        ui: {
            "counter": ".counter-num",
            "text": ".counter-text"
        },

        initialize: function (options) {

            this.settings = _.extend({}, Counter.DEFAULTS, options);

            this._checkInitialization(options);

            this.timeOutHandler = -1;
            this.logger = Logger.getLogger("CounterWidget");
            this.text = options.text || this.$el.text();
            this.direction = this._getDirection();

            this.container=options.container;

            if (_.isObject(options.collection)){ //do counter for collection
                this._counterForCollection(options.collection);
            }

            else {//do counter for number
                this._counterForNumber(options.number);
            }
        },

        _getDirection: function(){

            return this.settings.direction === "down" ? -1 : 1;
        },

        customTemplateHelpers: function () {

            return {
                permutationClass: this.settings.permutation
            };
        },

        onRender: function () {

            if (this.settings.permutation === Counter.PERMUTATION.C){
                this.ui.counter.insertBefore(this.ui.text);
            }
            if(this.container){
                $(this.container).append(this.el);
            }
            this._startCounter();
        },

        _counterForNumber: function (number) {

            this.model = new Backbone.Model({
                "text": this.text,
                "start": this.settings.start,
                "end": number
            });
        },

        _counterForCollection: function (collection) {

            if (this.settings.trackCollectionEvents === true){ //track collection change event
                this.listenTo(collection, "add remove reset", this._collectionChanged);
            }

            this._counterForNumber(collection.length);
        },

        _collectionChanged: function () {

            this.ui.counter.text(this.model.get("start"));

            this._counterForCollection(this.settings.collection);

            this._startCounter();
        },

        _startCounter: function(){

            var lowest =  this.model.get("start");
            var highest = this.model.get("end");
            var totalCount = highest -lowest;
            var dir = this.direction;
            var startNum = dir > 0 ? lowest : highest;
            var endNum = dir > 0 ?  highest : lowest;
            var currentNum = startNum;

            this._scheduleAdvanceOfCounter(startNum, endNum, currentNum, dir, totalCount, 1);

        },

        _scheduleAdvanceOfCounter: function(startNum, endNum, currentNum, dir, totalCount, speed){

            var advance = function(){
                this._advanceCounter(startNum, endNum, currentNum, dir, totalCount);
            };

            if (!this.uiClosing){
                this.timeOutHandler = setTimeout(_.bind(advance, this),speed);
            }
        },

        _advanceCounter : function(startNum, endNum, currentNum, dir, totalCount){

            this.timeOutHandler = -1;

            var togo =  dir === 1 ? endNum - currentNum : currentNum - endNum;
            var speed;

            if (togo > 0){

                speed = this._calculateSpeed(togo, totalCount);
                currentNum += dir;

                this.ui.counter.text(currentNum);

                this._scheduleAdvanceOfCounter(startNum, endNum, currentNum, dir, totalCount, speed);

            }
            else if(this.settings.closeOnDone){
                if(_.isFunction(this.settings.closeOnDone)){
                    this.settings.closeOnDone();
                }
                this.close();
            }
        },

        _calculateSpeed: function(togo, totalCount){

            var speed = this.settings.minSpeed - togo;

            speed = (speed < this.settings.maxSpeed ? this.settings.maxSpeed : speed); //dont go faster than max speed
            speed = (speed > this.settings.minSpeed ? this.settings.minSpeed : speed); //dont go slower than min speed
            speed = (togo < totalCount * this.settings.lastPercent ? speed * (1 + this.settings.lastPercent) : speed); //slow down a bit based on the last percent settings

            return speed;
        },

        _checkInitialization: function (options) {

            if (!_.isPlainObject(options)) {
                throw new Error("Counter widget must be initialized");
            }

            if (!_.isObject(options.collection) && !_.isNumber(options.number)) {
                throw new Error("Counter widget requires a Collection or a Number");
            }

            if (!_.isNumber(this.settings.lastPercent) || this.settings.lastPercent > 0.5){
                throw new Error("Counter widget requires a valid 'last percent' value, number less than 0.5");
            }
        },

        onClose: function () {

            this.uiClosing = true;

            if (this.timeOutHandler > -1){
                clearTimeout(this.timeOutHandler);
                this.timeOutHandler = -1;
            }
        }
    });

    Counter.DIRECTION = {
        "UP": "up",
        "DOWN": "down"
    };

    Counter.PERMUTATION = {
        "A": "perm-A", //text at top
        "B": "perm-B",  //text to the right
        "C": "perm-C",  //text to the bottom,
        "PERSISTENT-COUNTER":"perm-persistent-counter"
    };

    Counter.DEFAULTS = {
        "direction": Counter.DIRECTION.UP,
        "permutation": Counter.PERMUTATION.A,
        "start": 0,
        "trackCollectionEvents": true,
        "lastPercent": 0.05,
        "minSpeed" : 110,
        "maxSpeed": 20,
        "closeOnDone":false

    };

    return Counter;
});
